// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".code-input[data-v-78b58fc9] {\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n  justify-content: center;\n}\n.code-input input[data-v-78b58fc9] {\n  width: 75px;\n  height: 100px;\n  border: 2px solid #d1d1d1;\n  text-align: center;\n  font-size: 3rem;\n  font-weight: 700;\n  line-height: 4rem;\n  border-radius: 8px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
